import * as React from "react";
import { expandAllEvent } from "../../../../utils/eventTracking";
import { ViewMode } from "../../../../context/analysis/types";
import { clearPersistedUI } from "../../../../utils/storage";
import { EXPANDING_KEY } from "../constants";

export const useExpandedState = (firstRender: boolean, viewMode: ViewMode) => {
  const [expandAll, setExpandAll] = React.useState(false);
  React.useEffect(() => {
    if (firstRender) {
      firstRender = false;
    } else {
      clearPersistedUI(EXPANDING_KEY[viewMode]);
      expandAllEvent(expandAll);
    }
  }, [expandAll]);

  return {
    expandAll,
    setExpandAll,
  };
};
